module.exports = __webpack_public_path__ + "static/img/a304.e3e44fd8.png";